module.exports = __webpack_public_path__ + "img/logo-singular-rank-colour.4601cc38.svg";